export enum CustomerContactsOrderingEnum {
  FullName = 'FullName',
}
